import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../context/AuthContext";
import { Link } from "react-router-dom";
import { useLoading } from "../context/LoadingContext";
import { useAlert } from "../context/AlertContext";
import { useModal } from "../context/ModalContext";

export default function LoginPage() {
  const { login, isAuthenticated } = useContext(AuthContext);
  const {showLoading, hideLoading} = useLoading();
  const {showAlert} = useAlert();
  const {openModal } = useModal();
  if (isAuthenticated) {
    window.location.href = "/";
  }

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  async function handleSubmit(e) {
    e.preventDefault();
    try {
      showLoading();
      await login(email, password);
      showAlert('success', "Login success")
      window.location.href = "/";
    } catch(ex) {
      showAlert('danger', "Something wrong!")
      console.log(ex);
    }
    finally {
      hideLoading()
    }
  }
  return (
    <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "100vh" }}>
      <div className="card shadow-sm p-4" style={{ width: "380px", borderRadius: "12px" }}>

        <h3 className="text-center mb-3">Đăng nhập</h3>

        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label>Email</label>
            <input
              className="form-control"
              placeholder="Nhập email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div className="mb-3">
            <label>Mật khẩu</label>
            <input
              className="form-control"
              placeholder="Nhập mật khẩu"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <button className="btn btn-primary w-100 mt-2" type="submit">
            Đăng nhập
          </button>

          <div className="text-center mt-3">
            <Link to="/forgot-password" className="text-decoration-none">
              Quên mật khẩu?
            </Link>
          </div>

          <div className="text-center mt-2">
            <span>Chưa có tài khoản? </span>
            <Link to="/register" className="fw-bold text-decoration-none">
              Đăng ký ngay
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
}
